import {AppComponent} from './app.component';
import {BrowserModule} from '@angular/platform-browser';
import {FormBuilder, FormsModule} from '@angular/forms';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatIconRegistry,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule
} from '@angular/material';
import {KeysPipe} from './filters/keys-filter.pipe';
import {HeaderComponent} from './components/header/header.component';

import {UrlParamService} from './services/utils/url-param.service';
import {LoginService} from './services/login/login.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {MapComponent} from './components/map/map.component';
import {ConfigParamsService} from './services/configParameters/config-params.service';

import {GisWebComponent} from './components/gisweb/gisweb.component';

import {Ng2CompleterModule} from 'ng2-completer';

import {TutorialDialogComponent} from './components/tutorial-dialog/tutorial-dialog.component';
import {FeatureEditionPanelComponent} from './components/feature-edition-panel/feature-edition-panel.component';
import {AddimageService} from './services/data/addimage.service';
import {InsertFeatureService} from './services/data/insert-feature.service';
import {UpdateFeatureService} from './services/data/update-feature.service';
import {DeleteFeatureService} from './services/data/delete-feature.service';


import {SimpleNotificationsModule} from 'angular2-notifications';
import {LayerGridComponent} from './components/layer-grid/layer-grid.component';
import {NotificationDialogComponent} from './components/notification-dialog/notification-dialog.component';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {CookieService} from 'ngx-cookie-service';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {MapService} from './services/map/map.service';
import {ExpansionPanelListComponent} from './components/expansion-panel-list/expansion-panel-list.component';
import {ConfigService} from './services/utils/config.service';
import {SignatureComponent} from './components/signature/signature.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import {PublicLayoutComponent} from './layouts/public-layout/public-layout.component';
import {PrivateLayoutComponent} from './layouts/private-layout/private-layout.component';
import {HomeRedirectGuard} from './guard/HomeRedirectGuard';
import {AppRoutesGuard} from './guard/AppRoutesGuard';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {AuthInterceptor} from './interceptor/AuthInterceptor';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initConfig(configService: ConfigService): () => Promise<any> {
    return () => configService.loadConfig();
}

const appRoutes: Routes = [
    {path: '', canActivate: [HomeRedirectGuard], component: HomeComponent},

    {
        path: 'public',
        canActivate: [AppRoutesGuard],
        component: PublicLayoutComponent,
        children: [
            {path: '', component: HomeComponent},
            {path: 'visor', component: GisWebComponent}
        ]
    },

    {
        path: 'privat',
        canActivate: [AppRoutesGuard],
        component: PrivateLayoutComponent,
        children: [
            {path: '', component: LoginComponent},
            {path: 'visor', component: GisWebComponent}
        ]
    },

    {path: 'not-found', component: NotFoundComponent},

    {path: '**', redirectTo: 'not-found'}
];


@NgModule({
    declarations: [
        AppComponent,
        PublicLayoutComponent,
        PrivateLayoutComponent,
        HeaderComponent,
        HomeComponent,
        KeysPipe,
        MapComponent,
        FeatureEditionPanelComponent,
        TutorialDialogComponent,
        LayerGridComponent,
        GisWebComponent,
        NotificationDialogComponent,
        LoginComponent,
        ExpansionPanelListComponent,
        SignatureComponent,
        NotFoundComponent,
    ],
    entryComponents: [TutorialDialogComponent, NotificationDialogComponent],
    imports: [
        HttpClientModule,
        RouterModule.forRoot(appRoutes),
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatGridListModule,
        MatSidenavModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatCardModule,
        MatDialogModule,
        MatListModule,
        MatExpansionModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatSnackBarModule,
        Ng2CompleterModule,
        MatNativeDateModule,
        SimpleNotificationsModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        CookieService,
        UrlParamService,
        ConfigParamsService,
        LoginService,
        Location, {provide: LocationStrategy, useClass: PathLocationStrategy},
        FormBuilder,
        MatIconRegistry,
        AddimageService,
        InsertFeatureService,
        UpdateFeatureService,
        DeleteFeatureService,
        MapService,
        ConfigService,
        HomeRedirectGuard,
        AppRoutesGuard,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [ConfigService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/app.module.ts